// component 1 (Modified)
import React, { createContext, useContext } from "react";
import { useStaticList } from "./useStaticList"; // Your original hook for brands/categories
import { useStaticDefaultField } from "./useStaticDefaultField"; // Your original hook for staticContent/default
import { useDynamicCategories } from "./utils/useDynamicCategories"; // <-- Import the dynamic hook

const StaticListContext = createContext();

export const StaticListProvider = ({ children }) => {
  // --- Hooks for specific documents (brands, categories) ---
  const brandData = useStaticList("brands");
  const categoryData = useStaticList("categories");

  // --- Hooks for fields within staticContent/default ---
  // Initialize the hook for each relevant array field shown in the image
  const bannerBottomData = useStaticDefaultField("bannerBottom");
  const bannersData = useStaticDefaultField("banners");
  const featuredProductsData = useStaticDefaultField("featuredProducts");
  const featuresData = useStaticDefaultField("features");
  const historyData = useStaticDefaultField("history");
  const logosData = useStaticDefaultField("logos");
  const promisesData = useStaticDefaultField("promises");
  const storesData = useStaticDefaultField("stores");
  const yearProductData = useStaticDefaultField("yearProduct");
  // Add any other fields from 'staticContent/default' if needed

  // --- Hook for Dynamic Categories ---
  // Destructure the return values from your dynamic hook
  const {
    categoryBrandMap, // The full { category: [brands], ... } object
    categories: dynamicCategoryList, // Rename to avoid conflict with categoryData.categories
    loading: dynamicCategoriesLoading, // Rename loading state
    error: dynamicCategoriesError, // Rename error state
    fetchData: fetchDynamicCategories, // Rename fetch function
    addBrandToCategory, // Function to add a brand
    deleteBrandFromCategory, // Function to delete a brand
    deleteAllBrandsFromCategory: deleteAllBrandsFromCategory,
  } = useDynamicCategories(); // <-- Call your new hook here

  // --- Construct the context value ---
  const contextValue = {
    brands: {
      list: brandData.brands,
      loading: brandData.loading,
      error: brandData.error,
      add: brandData.addBrand,
      delete: brandData.deleteBrand,
      fetch: brandData.fetchBrands,
    },
    categories: {
      list: categoryData.categories,
      loading: categoryData.loading,
      error: categoryData.error,
      add: categoryData.addCategorie, // Correct name from useStaticList
      delete: categoryData.deleteCategorie, // Correct name from useStaticList
      fetch: categoryData.fetchCategories, // Correct name from useStaticList
    },
    defaultContent: {
      bannerBottom: bannerBottomData, // Expose the full return object of the hook
      banners: bannersData,
      featuredProducts: featuredProductsData,
      features: featuresData,
      history: historyData,
      logos: logosData,
      promises: promisesData,
      stores: storesData,
      yearProduct: yearProductData,
    },
    // --- Add Dynamic Categories Data/Functions to Context ---
    dynamicCategories: {
      // <-- NEW: Add a key for dynamic data
      categoryBrandMap: categoryBrandMap, // The main data map
      categoriesList: dynamicCategoryList, // The list of category names
      loading: dynamicCategoriesLoading, // Loading state for dynamic data
      error: dynamicCategoriesError, // Error state for dynamic data
      fetch: fetchDynamicCategories, // Expose the fetch function
      addBrand: addBrandToCategory, // Expose the add function (renamed for consistency)
      deleteBrand: deleteBrandFromCategory, // Expose the delete function (renamed for consistency)
      deleteAllBrandsFromCategory: deleteAllBrandsFromCategory,
    },
  };

  return (
    <StaticListContext.Provider value={contextValue}>
      {children}
    </StaticListContext.Provider>
  );
};

// --- Consumer Hook ---
// No change needed here, still use the same hook to access the context
export const useStaticData = () => useContext(StaticListContext);
